/**
 * Regras de Negócio e Cálculos de Aprendizagem (CLT / Lei da Aprendizagem)
 *
 * Módulo extraído para permitir reutilização determinística entre TCA,
 * TCA Empregador e suítes de testes, eliminando ciclos de dependência.
 */

export const calcularSalarioMinimoPorCargaHoraria = (
  salarioMinimoVigente,
  horasDiarias,
) => {
  if (horasDiarias !== 4 && horasDiarias !== 6) return null;
  const horasSemanais = horasDiarias * 5;
  const valorHora = Math.round((salarioMinimoVigente / 220) * 100) / 100;
  const valorSemanal = valorHora * horasSemanais;
  return Math.round(((valorSemanal * 4.4285 * 7) / 6) * 100) / 100;
};

export const buildMensagemSalarioInferiorMinimo = (
  salarioInformado,
  salarioMinimoCalculado,
  horasDiarias,
) => {
  const fmt = (v) =>
    Number(v || 0).toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  return `O salário informado (R$ ${fmt(salarioInformado)}) é inferior ao valor mínimo calculado pelo sistema (R$ ${fmt(salarioMinimoCalculado)}) para a carga horária de ${horasDiarias} horas diárias.`;
};

/**
 * Verifica se o salário informado é inferior ao mínimo calculado.
 * Retorna `null` quando está ok, ou um objeto { salarioMinimoCalculado, horasDiarias }
 * pronto para virar mensagem de erro.
 */
export const validarSalarioMinimo = (
  salarioInformado,
  salarioMinimoVigente,
  horasDiarias,
) => {
  const salarioMinimoCalculado = calcularSalarioMinimoPorCargaHoraria(
    salarioMinimoVigente,
    horasDiarias,
  );
  if (salarioMinimoCalculado === null) return null;
  if (salarioInformado < salarioMinimoCalculado) {
    return { salarioMinimoCalculado, horasDiarias };
  }
  return null;
};

export const getLimiteHorasAprendizagem = (cursos, cursoValor) => {
  if (!Array.isArray(cursos) || !cursoValor) return null;

  const cursoSelecionado = cursos.find((curso) => {
    if (!curso) return false;
    if (curso.valorObj) {
      const fullDesc = `${curso.valorObj.curso} — ${curso.valorObj.carga_horaria} (${curso.valorObj.modalidade})`;
      const cursoModalidade = `${curso.valorObj.curso} (${curso.valorObj.modalidade})`;
      return (
        fullDesc === cursoValor ||
        cursoModalidade === cursoValor ||
        curso.valorObj.curso === cursoValor ||
        String(curso.id) === String(cursoValor)
      );
    }
    return (
      String(curso.id) === String(cursoValor) || curso.curso === cursoValor
    );
  });

  if (!cursoSelecionado) return null;

  const cargaDiariaExplicita = Number(
    cursoSelecionado.valorObj?.carga_horaria_diaria ??
      cursoSelecionado.carga_horaria_diaria,
  );
  if (cargaDiariaExplicita === 4 || cargaDiariaExplicita === 6) {
    return cargaDiariaExplicita;
  }

  const rawCarga =
    cursoSelecionado.valorObj?.carga_horaria ??
      cursoSelecionado.carga_horaria ??
      cursoSelecionado.cargaHoraria;

  const cargaNumerica = Number(
    String(rawCarga ?? "")
      .replace(/[^\d]/g, "")
      .trim(),
  );

  if (cargaNumerica === 1936 || cargaNumerica === 4) return 4;
  if (cargaNumerica === 2230 || cargaNumerica === 6) return 6;
  return null;
};
